var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCred(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1480,
    height: 480,
    viewBox: "0 0 1480 480",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 740 240)",
    id: "e9d9b375-0043-4e60-b0bb-7a6badd75181"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -740,
    y: -240,
    rx: 0,
    ry: 0,
    width: 1480,
    height: 480
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "155c6f1c-3c57-491f-b308-fc00fd39e070"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29 0 0 1.29 740 240)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -490 -490)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -50,
    y: -50,
    rx: 0,
    ry: 0,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51 0 0 1.61 -320.35 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,11,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-187.45, -299.6)",
    d: "M 187.5 396.5 C 186.4 396.5 185.4 396.2 184.4 395.7 L 105.4 351.2 C 103.4 350.09999999999997 102.2 348.09999999999997 102.2 345.8 L 102.2 208.9 C 102.2 205.5 104.9 202.70000000000002 108.4 202.70000000000002 L 266.5 202.70000000000002 C 269.9 202.70000000000002 272.7 205.4 272.7 208.9 L 272.7 345.8 C 272.7 348 271.4 350.1 269.5 351.2 L 190.5 395.7 C 189.5 396.3 188.6 396.5 187.5 396.5 L 187.5 396.5 z M 114.7 342.3 L 187.5 383.3 L 260.4 342.3 L 260.4 215.1 L 114.7 215.1 L 114.7 342.3 z M 114.7 342.3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51 0 0 1.61 -322.69 19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,11,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-185.9, -311.4)",
    d: "M 187.5 334.6 C 186.4 334.6 185.4 334.3 184.4 333.8 L 159.4 319.6 C 157.4 318.5 156.20000000000002 316.5 156.20000000000002 314.20000000000005 L 156.20000000000002 288.20000000000005 L 168.60000000000002 288.20000000000005 L 168.60000000000002 310.50000000000006 L 187.50000000000003 321.1000000000001 L 209.50000000000003 308.7000000000001 L 215.60000000000002 319.5000000000001 L 190.60000000000002 333.7000000000001 C 189.5 334.3 188.6 334.6 187.5 334.6 L 187.5 334.6 z M 187.5 334.6",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51 0 0 1.61 -320.42 18.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,11,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-187.4, -311.2)",
    d: "M 187.5 365.6 C 186.4 365.6 185.4 365.3 184.4 364.8 L 132.3 335.5 C 130.3 334.4 129.10000000000002 332.3 129.10000000000002 330.1 L 129.10000000000002 263 C 129.10000000000002 259.6 131.8 256.8 135.3 256.8 L 211.70000000000002 256.8 L 211.70000000000002 269.2 L 141.5 269.2 L 141.5 326.59999999999997 L 187.3 352.4 L 233.10000000000002 326.59999999999997 L 233.10000000000002 299.7 L 245.70000000000002 299.7 L 245.70000000000002 330 C 245.70000000000002 332.2 244.4 334.3 242.50000000000003 335.4 L 190.40000000000003 364.7 C 189.5 365.4 188.6 365.6 187.5 365.6 L 187.5 365.6 z M 187.5 365.6",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.51 0 0 1.61 36.92 -27.21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(32,11,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-424.05, -282.7)",
    d: "M 245.7 276 L 233.29999999999998 276 L 233.29999999999998 242.2 L 151.09999999999997 242.2 L 151.09999999999997 229.79999999999998 L 239.39999999999998 229.79999999999998 C 242.79999999999998 229.79999999999998 245.59999999999997 232.49999999999997 245.59999999999997 235.99999999999997 L 245.59999999999997 276 L 245.7 276 z M 331.5 288.8 C 331.5 262.3 351.2 241.9 378.3 241.9 C 394.6 241.9 409 250 416.8 262.8 L 399.1 273.1 C 395.1 266.20000000000005 387.3 262 378.3 262 C 362.40000000000003 262 352.1 272.7 352.1 288.8 C 352.1 305 362.40000000000003 315.6 378.3 315.6 C 387.40000000000003 315.6 395.3 311.5 399.1 304.5 L 416.8 314.8 C 409.2 327.5 394.7 335.6 378.3 335.6 C 351.2 335.6 331.5 315.3 331.5 288.8 L 331.5 288.8 z M 594 315.5 L 594 335.5 L 533.2 335.5 L 533.2 241.9 L 594 241.9 L 594 261.9 L 554.6 261.9 L 554.6 277.9 L 589.3000000000001 277.9 L 589.3000000000001 298.2 L 554.6 298.2 L 554.6 315.3 L 594 315.3 L 594 315.5 z M 492.6 301.3 C 502.90000000000003 296.1 509.90000000000003 285.5 509.90000000000003 274.1 C 509.90000000000003 256.20000000000005 495.6 241.90000000000003 477.90000000000003 241.90000000000003 L 440.40000000000003 241.90000000000003 L 440.40000000000003 335.6 L 461.8 335.6 L 461.8 304.90000000000003 L 472 304.90000000000003 L 489.6 335.6 L 512.6 335.6 L 492.6 301.3 z M 477.8 286.1 L 461.8 286.1 L 461.8 262 L 477.8 262 C 483.6 262 488.40000000000003 267.3 488.40000000000003 274.1 C 488.4 280.9 483.6 286.1 477.8 286.1 L 477.8 286.1 z M 651.6 241.9 L 617.2 241.9 L 617.2 335.3 L 651.6 335.3 C 677.3000000000001 335.3 697 315 697 288.5 C 697 262.2 677.4 241.9 651.6 241.9 L 651.6 241.9 z M 651.6 315.5 L 638.6 315.5 L 638.6 262 L 651.6 262 C 666.2 262 676.4 272.6 676.4 288.7 C 676.5 304.7 666.4 315.5 651.6 315.5 L 651.6 315.5 z M 651.6 315.5",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCred);
export default __webpack_public_path__ + "static/media/cred.8e746a6c822248b390e3e74d73566c2a.svg";
export { ForwardRef as ReactComponent };